import { render } from "./DenialOfResponsibility.vue?vue&type=template&id=48581614"
import script from "./DenialOfResponsibility.vue?vue&type=script&lang=js"
export * from "./DenialOfResponsibility.vue?vue&type=script&lang=js"

import "./DenialOfResponsibility.vue?vue&type=style&index=0&id=48581614&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__